<nz-spin [nzSpinning]="loading">
    <div class="container quizzes-container">
        <div class="page-header">
            <div>
                <h2>Provider Payplans</h2>
                <p class="page-subtitle">Review and maintain provider pay plan details.</p>
            </div>
            <button nz-button nzType="primary" (click)="payplanModal = true">
                <span nz-icon nzType="plus" nzTheme="outline"></span>
                New Payplan
            </button>
        </div>

        <nz-table #basicTable [nzData]="providerPlans" [nzFrontPagination]="false" nzBordered>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Provider</th>
                    <th>Company</th>
                    <th>Created</th>
                    <th>Created By</th>
                    <th>Type</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let plan of providerPlans">
                    <td>{{ plan.name }}</td>
                    <td>
                        <span class="status-tag" [ngClass]="plan.status">{{ plan.status | titlecase }}</span>
                    </td>
                    <td>{{ plan.provider }}</td>
                    <td>{{ plan.company | titlecase }}</td>
                    <td>{{ plan.created_at | date: 'mediumDate' }}</td>
                    <td>{{ plan.user | titlecase }}</td>
                    <td>{{ plan.type | titlecase }}</td>
                    <td class="table-actions">
                        <a (click)="openEdit(plan)">Edit</a>
                        <a class="danger" *ngIf="plan.status == 'active'" (click)="statusPlan(plan)">Deactivate</a>
                        <a *ngIf="plan.status == 'inactive'" (click)="statusPlan(plan)">Activate</a>
                    </td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</nz-spin>


<nz-modal [(nzVisible)]="payplanModal" nzTitle="Provider Payplan" nzWidth="720px" (nzOnCancel)="closePlan()" (nzOnOk)="addPayplan()">
    <ng-container *nzModalContent>
        <form [formGroup]="payplanForm" class="modal-form">
            <div class="modal-grid">
                <div class="modal-field">
                    <label class="modal-label">Name</label>
                    <input nz-input formControlName="name" placeholder="Plan Name" />
                </div>
            </div>
            <div class="modal-field">
                <label class="modal-label">Provider</label>
                <nz-select nzShowSearch nzAllowClear formControlName="provider_id" nzPlaceHolder="Select Provider">
                    <nz-option *ngFor="let p of providers" [nzValue]="p.id" [nzLabel]="p.name"></nz-option>
                </nz-select>
            </div>
            <div class="modal-field">
                <label class="modal-label">Company</label>
                <nz-select nzShowSearch nzAllowClear formControlName="company_id" nzPlaceHolder="Select Company">
                    <nz-option *ngFor="let c of companies" [nzValue]="c.id" [nzLabel]="c.name"></nz-option>
                </nz-select>
            </div>
            <div class="modal-field">
                <label class="modal-label">Type</label>
                <nz-select nzShowSearch nzAllowClear formControlName="type" nzPlaceHolder="Select Type">
                    <nz-option *ngFor="let t of planTypes" [nzValue]="t.value" [nzLabel]="t.label"></nz-option>
                </nz-select>
            </div>
        </form>
    </ng-container>
</nz-modal>